import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const Footer = () => (
  <footer className="bg-ink text-paper" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 md:px-10 pt-24 pb-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-20 border-b border-paper/10">
        <div className="md:col-span-7">
          <p className="text-xs uppercase tracking-[0.35em] text-paper/40">Axiom Computers · Consultancy &amp; Research</p>
          <h2 className="mt-6 font-display text-4xl md:text-5xl tracking-tight leading-tight">
            Let&rsquo;s build<br />what&rsquo;s <em className="text-cobalt not-italic border-b-2 border-cobalt">next</em>.
          </h2>
          <a
            href="mailto:help@axiomcomputers.com"
            data-testid="footer-email-link"
            className="mt-8 inline-flex items-center gap-2 text-paper/70 hover:text-cobalt transition-colors duration-300 text-lg"
          >
            help@axiomcomputers.com <ArrowUpRight size={18} />
          </a>
        </div>
        <div className="md:col-span-3 md:col-start-10">
          <p className="text-xs uppercase tracking-[0.3em] text-paper/40 mb-6">Site</p>
          <ul className="space-y-3 text-paper/70">
            {[["Home", "/"], ["Services", "/services"], ["About", "/about"], ["Contact", "/contact"]].map(([label, to]) => (
              <li key={to}>
                <Link to={to} data-testid={`footer-link-${label.toLowerCase()}`} className="hover:text-cobalt transition-colors duration-300">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="pt-10 flex flex-col md:flex-row justify-between gap-4 text-sm text-paper/40">
        <p>© 2026 Axiom Research and Development (AI &amp; Computation Engineering). All rights reserved.</p>
        <p>Meerut · Delhi (NCR) · India</p>
      </div>
    </div>
    <div className="overflow-hidden select-none" aria-hidden="true">
      <p className="font-bold text-[19vw] leading-[0.8] text-center text-outline tracking-tight -mb-[4vw]">
        ∆XIOM
      </p>
    </div>
  </footer>
);

export default Footer;
